import React, { useMemo, useState } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import "../style.scss";
import { Detalhes } from "~misc/icons";
import ModalDetalhesIndicadores from "./ModalDetalhesIndicadores";
import RocketAnimation from "./RocketAnimation";
import { MarcacaoReflex } from "~misc/png_logos";
import { atingiuMeta, getDirecaoMetas } from "../utils";

const Speedometer = ({ pontuacao, indicador, parametroReflex, isHistorico, isMesAtual }) => {
  const [openDetalhes, setOpenDetalhes] = useState(false);

const valorExibido = useMemo(() => {
  const v = Number(pontuacao);
  if (!Number.isFinite(v)) return 0;

  let proj = null;
  let m500 = null;

  if (indicador) {
    proj = Number(indicador?.volumes?.projetadoAjustado);
    m500 = Number(indicador?.metas?.m500);
  }

  if (v >= 500) {

    if (
      indicador &&
      atingiuMeta({
        valor: proj,
        meta: m500,
        direcao: getDirecaoMetas(indicador?.metas),
        inclusive: false,
      })
    ) {
      return 550;
    }

    return 500;
  }

  return v;
}, [pontuacao, indicador]);


    const bonusAtingido = useMemo(() => {
      if (!indicador) return false;

      const { volumes, metas } = indicador;
      return Number(pontuacao) >= 500 && atingiuMeta({
        valor: Number(volumes?.projetadoAjustado),
        meta: Number(metas?.m500),
        direcao: getDirecaoMetas(metas),
      });
    }, [pontuacao, indicador]);

  return (
    <>
      <div className=" speed relative flex flex-col items-center bg-white pr-4 scale-[0.9] mb-4">
         <div className="tags  flex justify-center ">
            <div className="bg-[#1F61AB] text-white text-[13px] px-5 py-1 rounded-full  font-medium mx-auto max-w-[200px] text-center">
                Peso do Indicador: <span className="font-bold">{indicador.pesoPercentual}%</span>
            </div>
        </div>
        <div className="speed-img">
          <MarcacaoReflex />
        </div>

        <ReactSpeedometer
          value={valorExibido}
          minValue={0}
          maxValue={600}
          segments={4}

          customSegmentStops={[0, 100, 300, 500, 600]}
          segmentColors={["#E4542F", "#FCC729", "#89B33A", "#126347"]}
          needleColor="black"
          needleBaseColor="black"
          ringWidth={30}
          textColor="#000"
          currentValueText=""
          height={230}
          customSegmentLabels={[
            { text: "0", position: "OUTSIDE", color: "#000", fontSize: "10px" },
            { text: "100", position: "OUTSIDE", color: "#000", fontSize: "10px" },
            { text: "300", position: "OUTSIDE", color: "#000", fontSize: "10px" },
            { text: "500", position: "OUTSIDE", color: "#000", fontSize: "10px" },
          ]}
        />
        <div className={`bonus ${bonusAtingido ? "atingido" : ""}`}>
          <span className="text-xs font-bold text-green-600">Crédito</span>
          <div className="rocket">
          <RocketAnimation />
          </div>
        </div>
        <div className="text-center  absolute bottom-[-20px] flex flex-col items-center">
          <p className="text-3xl font-bold text-xl"> {Math.min(Math.trunc(pontuacao), 500)}</p>
          <p className="font-semibold text-sm">Pontos</p>
          <button
            type="button"
            onClick={() => indicador && setOpenDetalhes(true)}
            className="flex items-center gap-2 px-6 py-2  rounded-full bg-[#0057B7]  text-white font-semibold shadow-sm border border-[#8AB4F8] hover:bg-[#004a9e] transition">
            <span>DETALHES</span>
            <Detalhes />
          </button>
        </div>

      </div>

      {indicador && (
        <ModalDetalhesIndicadores
          isOpen={openDetalhes}
          onClose={() => setOpenDetalhes(false)}
          indicador={indicador}
          parametroReflex={parametroReflex}
          isHistorico={isHistorico}
          isMesAtual={isMesAtual}
        />
      )}
    </>
  );
};

export default Speedometer;
